import { Card } from '@digdir/designsystemet-react';
import React, { FC } from 'react';

import { Tiltak, TiltakKategori } from '../../../../../types/registration/tiltak';

import { TiltakSection } from './tiltakSection';

interface Props {
  tiltakList?: Tiltak[];
}

export const TiltakCard: FC<Props> = ({ tiltakList }) => {
  if (!tiltakList || tiltakList.length === 0) {
    return null;
  }

  // Create a map with TiltakKategori and list of tiltak associated with that category
  const tiltakMap = new Map<TiltakKategori, Tiltak[]>();

  tiltakList?.forEach((tiltak) => {
    if (!tiltakMap.has(tiltak.tiltaksKategori)) {
      tiltakMap.set(tiltak.tiltaksKategori, []);
    }
    tiltakMap.get(tiltak.tiltaksKategori)?.push(tiltak);
  });

  return (
    <Card>
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Automatikkanlegg} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Brukertiltak} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Bygningsmessig} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.ElektriskAnlegg} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Egendefinert} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Generelle} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Luftbehandlingsanlegg} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Ovrige} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Sanitaeranlegg} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Utendors} />
      <TiltakSection tiltakMap={tiltakMap} category={TiltakKategori.Varmeanlegg} />
    </Card>
  );
};
